<div class="wrapper">

<header id="header">
    <div class="container">
        <nav class="navbar navbar-default">
            <a class="navbar-brand" [routerLink]="[ data.URL_HOME ] | localize"><img class="logo" src="./assets/imagens/logo_branca.png"></a>

            <ul class="navbar-nav float-right">
                <li>
                    <a [routerLink]="[ data.URL_HOME ] | localize"><i class="fa fa-home mr-2"></i>Home</a>
                </li>
            </ul>
        </nav>
    </div>
</header>

<main>
    <section id="intro">
        <div class="container">
            <div class="row justify-content-center align-items-center">
                <div class="col-lg-12 text-center">
                    <h2>{{ data.TITULO }}</h2>
                </div>
            </div>

            <div class="row justify-content-center align-items-center">
                <div class="col-lg-12 text-center">
                    <div class="embed-responsive embed-responsive-16by9 video">
                        <iframe class="embed-responsive-item" [src]="data.VIDEO.URL | safe" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>

<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center text-white">
                &copy; Copyright 2021 - <a class="text-white" href="http://www.sirius.co" target="_blank"><strong>Sirius
                        Software</strong></a>. {{ data.FOOTER.RODAPE.TITULO }}
            </div>
        </div>
    </div>
</footer>
</div>